import {
  faChevronDoubleLeft,
  faChevronDoubleRight,
  faChevronLeft,
  faChevronRight
} from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, IconButton, useMediaQuery } from "@mui/material"
import theme from "css/theme/light"
import { useTranslation } from "react-i18next"

const Pagination = (props) => {
  const { pageIndex, gotoPage, previousPage, nextPage, canPreviousPage, canNextPage, pageCount } = props
  const isPhone = useMediaQuery(theme.breakpoints.down("sm"))
  const { t } = useTranslation()

  const nextPageClick = () => {
    nextPage()
  }

  const previousPageClick = () => {
    previousPage()
  }

  const firstPageClick = () => {
    gotoPage(0)
  }

  const lastPageClick = () => {
    gotoPage(pageCount() - 1)
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <span>
        {!isPhone && t("global.table.page", "page")}
        <strong style={{ paddingLeft: !isPhone && "4px", paddingRight: "8px" }}>
          {pageCount() > 0 ? pageIndex : 0} {t("global.of", "of")} {pageCount()}
        </strong>
      </span>

      <IconButton onClick={firstPageClick} disabled={!canPreviousPage()} size="medium">
        <FontAwesomeIcon icon={faChevronDoubleLeft} size="xs" />
      </IconButton>
      <IconButton onClick={previousPageClick} disabled={!canPreviousPage()} size="medium">
        <FontAwesomeIcon width="1em" icon={faChevronLeft} size="xs" />
      </IconButton>
      <IconButton onClick={nextPageClick} disabled={!canNextPage()} size="medium">
        <FontAwesomeIcon width="1em" icon={faChevronRight} size="xs" />
      </IconButton>
      <IconButton onClick={lastPageClick} disabled={!canNextPage()} size="medium">
        <FontAwesomeIcon icon={faChevronDoubleRight} size="xs" />
      </IconButton>
    </Box>
  )
}

export default Pagination
